// Variáveis de ambiente opcionais (só definidas quando subdomínio está habilitado)
const SITE_DOMAIN = import.meta.env.VITE_SITE_DOMAIN as string | undefined; // ex: bolaoelite.com.br
const APP_DOMAIN = import.meta.env.VITE_APP_DOMAIN as string | undefined;   // ex: app.bolaoelite.com.br

/** Retorna true quando as variáveis de subdomínio estão configuradas */
export function isSubdomainEnabled(): boolean {
  return Boolean(SITE_DOMAIN && APP_DOMAIN);
}

/** Retorna true quando rodando em app.bolaoelite.com.br */
export function isOnAppSubdomain(): boolean {
  if (!APP_DOMAIN) return false;
  return window.location.hostname === APP_DOMAIN;
}

/** Retorna true quando rodando em bolaoelite.com.br (ou www.) */
export function isOnMainDomain(): boolean {
  if (!SITE_DOMAIN) return false;
  const hostname = window.location.hostname;
  return hostname === SITE_DOMAIN || hostname === `www.${SITE_DOMAIN}`;
}

export function getSiteDomain(): string {
  return SITE_DOMAIN || '';
}

export function getAppDomain(): string {
  return APP_DOMAIN || '';
}

/** Redireciona para o subdomínio app (área autenticada) */
export function navigateToApp(path: string = '/boloes'): void {
  if (APP_DOMAIN) {
    window.location.href = `https://${APP_DOMAIN}${path}`;
  }
}

/** Redireciona para o domínio principal (landing pública) */
export function navigateToSite(path: string = '/'): void {
  if (SITE_DOMAIN) {
    window.location.href = `https://${SITE_DOMAIN}${path}`;
  }
}
